<template>
  <div class="dialog-warp">
    <div class="dialog-form">
      <h3 class="title" style="padding-left: 20px;">{{serveInfo.serveType}}</h3>
      <div class="f-content">
        {{serveInfo.serveDes}}
      </div>
      <el-row style="padding: 20px;box-sizing: border-box;">
        <el-col>
          <div class="f-form-item">
            <div class="f-form-item-label">企业名称</div>
            <div class="f-form-item-content">{{serveInfo.serveCompanyName}}</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="f-form-item">
            <div class="f-form-item-label">联系人：</div>
            <div class="f-form-item-content">{{serveInfo.serveContactName}}</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="f-form-item">
            <div class="f-form-item-label">联系方式：</div>
            <div class="f-form-item-content">{{serveInfo.serveContactTelephone}}</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="f-form-item">
            <div class="f-form-item-label">联系地址：</div>
            <div class="f-form-item-content">{{serveInfo.serveContactAddress}}</div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="f-form-item">
            <div class="f-form-item-label">企业简介：</div>
            <div class="f-form-item-content">
              {{serveInfo.serveCompanyDes}}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="text-right" style="margin-top: 20px;">
      <el-button type="success" @click="close">确 &nbsp;&nbsp;&nbsp;&nbsp;认</el-button>
    </div>
  </div>
</template>

<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'

  export default {
    data() {
      return {
        serveInfo:{},
      }
    },
    created() {
    },
    mounted() {
      this.init();
    },
    props: ['type', 'serveId'],
    computed: {},
    methods: {
      init() {
        getData.serveDetail(this.serveId).then((res) => {
          if (res.data.code != 'success') {
            this.$message({
              type: 'error',
              message: res.data.message || res.data.Msg
            });
            return
          }
          this.serveInfo = res.data.data.serve;
        }).catch(_ => {

        });
      },
      close() {
        this.$emit('closeDialog')
      },

    },
    components: {},
    watch: {}
  }
</script>
<style scoped lang="scss">
  .title {
    font-size: 16px;
    font-weight: 600;
  }

  .f-content {
    min-height: 60px;
    padding: 20px;
    padding-top: 10px;
    word-break: break-all;
    border-bottom: 1px solid #e5e5e5;
  }

  .f-form-item {
    position: relative;
    width: 100%;
    min-height: 32px;
    display: flex;
    .f-form-item-label {
      width: 70px;
    }
    .f-form-item-content {
      flex: 1;
      word-break: break-all;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sever-detail.vue